import { motion } from 'framer-motion';

const HowItWorksSection = () => {
  const steps = [
    {
      number: '01',
      icon: 'ri-file-list-3-line',
      title: '基本情報を入力',
      description: '年齢、性別、体重、飲酒習慣などの基本情報を入力します。氏名や住所は不要です。',
      color: 'from-blue-500 to-blue-600',
    },
    {
      number: '02',
      icon: 'ri-test-tube-line',
      title: '血液データを入力',
      description: '健康診断の結果から、AST、ALT、血小板数を入力します。',
      color: 'from-green-500 to-green-600',
    },
    {
      number: '03',
      icon: 'ri-calculator-line',
      title: '自動計算',
      description: '国際指標（FIB-4 Index）に基づいて、自動的に計算を行います。',
      color: 'from-purple-500 to-purple-600',
    },
    {
      number: '04',
      icon: 'ri-file-chart-line',
      title: '結果を確認',
      description: 'リスクグループの分類と、参考情報をご確認いただけます。',
      color: 'from-orange-500 to-orange-600',
    },
  ];

  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">使い方</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            簡単4ステップで、数分でチェック完了
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-100 h-full">
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-r ${step.color} rounded-full mb-4`}>
                  <i className={`${step.icon} text-white text-3xl`}></i>
                </div>
                <div className="mb-3">
                  <span className="text-4xl font-bold text-gray-200">{step.number}</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-gray-300 text-2xl"></i>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-16 text-center"
        >
          <p className="text-sm text-gray-600 mb-6">所要時間：約3〜5分</p>
          <a
            href="/check"
            className="inline-block px-10 py-5 bg-gradient-to-r from-blue-600 to-green-600 text-white text-lg font-bold rounded-full hover:from-blue-700 hover:to-green-700 transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer"
          >
            今すぐ始める
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;